export default {"src":"https://search.testwiggot.com/_next/static/media/for-rent-last-7-days.b86648d0.svg","height":22,"width":30,"blurWidth":0,"blurHeight":0};